import { useRef } from "react";
import Image from "next/image";
import { useSectionNavTheme } from "@/app/hooks/useSectionNavTheme";
import { Heading2 } from "../typography";
import { PinnedScrollSection } from "../shared";

export const OurTechnology = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null);

  const technologies = [
    {
      title: "Scale monitoring",
      description:
        "Move from reactive, individual property inspections to proactive screening of thousands of properties simultaneously",
    },
    {
      title: "Target resources",
      description:
        "Focus limited compliance staff on properties where satellite data indicates potential non-compliance",
    },
    {
      title: "Improve accuracy",
      description:
        "Use objective satellite measurements instead of relying solely on self- reported meter readings",
    },
    {
      title: "Enhance transparency",
      description:
        "Provide consistent, data- driven monitoring across all properties using the same satellite-based methodology",
    },
  ];

  useSectionNavTheme({
    trigger: ".our-technology",
    isDark: false,
    start: "center center",
    end: () => `+=${technologies.length * 500 + window.innerHeight}`, // should be equal to mainTl + 100%
  });

  return (
    <section
      ref={sectionRef}
      className="our-technology pt-20 pb-64 relative"
      style={{
        backgroundImage:
          "linear-gradient(180deg, var(--color-haizea-dark) 0%, #2C665C 100%)",
      }}
    >
      <Image
        src="/images/satellite1.svg"
        alt="Background Satellite"
        height={350}
        width={430}
        className="absolute top-[100vh] -left-[300px] lg:-left-[5vw] h-auto"
        draggable={false}
        data-speed="0.5"
      />
      <Image
        src="/images/satellite2.svg"
        alt="Background Satellite"
        height={350}
        width={430}
        className="absolute bottom-10vh -right-[300px] lg:-right-[5vw] h-auto"
        draggable={false}
        data-speed="0.75"
      />

      <div className="our-technology__content">
        <div className="container">
          <div className="max-w-[710px] mx-auto">
            <PinnedScrollSection
              title={
                <Heading2 className="mb-8 text-4xl flex flex-col pl-16 md:pl-24 leading-snug">
                  <span className="text-[#51B873]">Our Technology</span>{" "}
                  <span className="text-white">enabled NRAR to:</span>
                </Heading2>
              }
              items={technologies}
              contentClassName="lg:h-[30vh]"
              yOffset={80}
              rangeBackground="rgba(255, 255, 255, 0.3)"
              titleClassName="font-medium text-slate-10"
              descriptionClassName="text-slate-200"
              itemClassName="text-2xl my-4 text-slate-200"
              maskGradient="linear-gradient(180deg,rgba(255, 255, 255, 0.2) 5%, rgba(255, 255, 255, 0.7) 10%, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 1) 70%, rgba(255, 255, 255, 0.5) 95%)"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
